import { combineReducers } from 'redux-immutablejs';
import { entityReducer } from 'app/models/entities/reducers';
import { ENTITY_PREFIX, REMOTE_PREFIX } from 'app/remote/constants';
import { storeReducer, remoteStateReducer } from 'app/remote/index';
import { authReducers } from 'app/models/auth/reducers';
import { AUTH_PREFIX } from 'app/models/auth/constants';
import { CLIENT_PREFIX } from 'app/remote/client/constants';
import { clientReducer } from 'app/remote/client/reducers';
import { editor } from 'app/models/editor/reducers';
import { autosaveReducer } from 'app/models/autosave/reducers';
import { SEARCH_LISTS_STORE_PREFIX } from 'app/models/searchLists/constants';
import searchListsReducer from 'app/models/searchLists/reducer';
import { publishedLessonListReducer } from 'app/models/publishedLessonList/reducer';
import { PUBLISHED_LESSONS_LIST_PREFIX } from 'app/models/publishedLessonList/constants';
import tagsReducer from 'app/models/tags/reducers';
import { TAGS_PREFIX } from 'app/models/tags/constants';
import { enableBatching } from 'redux-batched-actions';
import { PUBLISHED_LESSONS_ADMIN_PREFIX } from 'app/models/publishedLessonAdmin/constants';
import { publishedLessonAdminReducer } from 'app/models/publishedLessonAdmin/reducer';
import { publishLessonUIReducer } from 'app/models/ui/publishLesson/reducer';
import { PUBLISH_LESSON_UI_PREFIX } from 'app/models/ui/publishLesson/constants';
import { VALIDATIONS_PREFIX } from 'app/models/validations/constants';
import { validationErrorsReducer } from 'app/models/validations/reducers';
import { LOCAL_STORAGE_PREFIX } from 'app/models/localStorage/constants';
import { localStorageReducers } from 'app/models/localStorage/reducers';
import { SESSION_STORAGE_PREFIX } from 'app/models/sessionStorage/constants';
import { sessionStorageReducers } from 'app/models/sessionStorage/reducers';
import { CALL_PREFIX } from 'app/models/ui/call/constants';
import callReducer from 'app/models/ui/call/reducer';
import { BANNERS_PREFIX } from 'app/models/banners/constants';
import bannersReducer from 'app/models/banners/reducer';

export const makeRootReducer = (customReducers = {}) => {
  const rootReducer = combineReducers({
    [REMOTE_PREFIX]: remoteStateReducer,
    [ENTITY_PREFIX]: entityReducer,
    editor,
    autosave: autosaveReducer,
    [AUTH_PREFIX]: authReducers,
    [SEARCH_LISTS_STORE_PREFIX]: searchListsReducer,
    [TAGS_PREFIX]: tagsReducer,
    [PUBLISHED_LESSONS_LIST_PREFIX]: publishedLessonListReducer,
    [PUBLISHED_LESSONS_ADMIN_PREFIX]: publishedLessonAdminReducer,
    [PUBLISH_LESSON_UI_PREFIX]: publishLessonUIReducer,
    [VALIDATIONS_PREFIX]: validationErrorsReducer,
    [LOCAL_STORAGE_PREFIX]: localStorageReducers,
    [CLIENT_PREFIX]: clientReducer,
    [SESSION_STORAGE_PREFIX]: sessionStorageReducers,
    [CALL_PREFIX]: callReducer,
    [BANNERS_PREFIX]: bannersReducer,
    ...customReducers,
  });

  return enableBatching(storeReducer(rootReducer));
};

export default makeRootReducer();
